import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {AppFlags} from '../../app/app-types';
import {connectAppEnv} from '../../app/app-env';
import {withIsOpenState, frefFromRef, frefToRef} from '../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import {OEViewType} from '../../lib/oe-types';
import OENotification from '../../lib/notification/oe-notification';
import retardUpdate from '../../lib/react/update-retarder';
import OEToolbox from '../../lib/tools/oe-toolbox';
import ServiceWorkerTool from '../../lib/tools/service-worker-tool';
import OEIconCodes from '../../lib/oe-icon-codes';
import OEButton from '../elements/controls/oe-button';
import {OEGroupControl, OEControl, OEButtonControl, OEIconButtonControl, OEToggleCheckboxControl} from '../elements/controls/oe-controls';
import OEPopover from '../views/oe-popover';
import {OEMainMenuStdBtnType} from '../bars/main-menu/oe-main-menu-model';
import {ServiceWorkerMessageType, ServiceWorkerClientMessageType, ServiceWorkerCacheState, ServiceWorkerNewCacheState, ServiceWorkerResultType} from './service-worker-model';
import {OEOfflineManagerProps} from './oe-offline-manager-model';

export class OEOfflineManagerController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.allowValidCacheUpdates = false;

        this.workerState = this.defaultWorkerState();

        this.state = {
            uiEnabled:                              false,
            workerState:                            clone(this.workerState),
            updating:                               false,
            strings:   {
                title:                              'Offline Capability',
                state: {
                    label:                          'State',
                    notAvailable:                   'not available',
                    available:                      'available',
                    active:                         'active',
                },
                cache: {
                    stateLabel:                     'Cache State',
                    none:                           'none',
                    invalid:                        'invalid',
                    valid:                          'valid',
                    needsUpdate:                    'needs Update',
                    creatingNew:                    'creating',
                    updateLabel:                    'Update Cache',
                },
                enableLabel:                        'Enabled',
                needsReloadLabel:                   'To apply changes a reload is needed.',
                reloadBtn:                          'Reload',
                alertOk:                            'OK',
                errorTitle:                         'Error',
                createNewCacheErrorMsg:             'Creating a new cache failed. Try again later.',
                storageExceededErrorMsg:            'Not enough storage available. %IN_USE% in use from %AVAILABLE% available.'
            }
        };

        this._updating = 0;

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onServiceWorkerMessage = this.onServiceWorkerMessage.bind(this);

        this.onUpdateCacheBtnPressed = this.onUpdateCacheBtnPressed.bind(this);
        this.onEnableSwitchChanged = this.onEnableSwitchChanged.bind(this);
        this.onReloadBtnPressed = this.onReloadBtnPressed.bind(this);
    }

    defaultWorkerState()    {
        return {
            isReady:                                false,
            enabled:                                false,
            currentEnabled:                         false,
            cacheState:                             ServiceWorkerCacheState.none,
            currentCacheState:                      ServiceWorkerCacheState.none,
            newCacheState:                          {state: ServiceWorkerNewCacheState.none}
        };
    }

    componentDidMount()    {
        this.mounted = true;

        OEToolbox.printStorageStats();

        ServiceWorkerTool.registerMessageListener(this.onServiceWorkerMessage);
        this.updating(this.updateWorkerState());

        ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.updateDataConfig});
    }
    
    componentWillUnmount()    {
        ServiceWorkerTool.unregisterMessageListener(this.onServiceWorkerMessage);
        this.mounted = false;
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage()   {
        const si = this.oe.sharedInterface;

        return;

        this.setState({
            strings: {
                title:                              si.getLocalizedStringEnc('offline_manager_view'),
                state: {
                    label:                          si.getLocalizedStringEnc('offline_manager_state_label'),
                    notAvailable:                   si.getLocalizedStringEnc('offline_manager_state_no_available'),
                    available:                      si.getLocalizedStringEnc('offline_manager_state_available'),
                    active:                         si.getLocalizedStringEnc('offline_manager_state_active'),
                },
                cache: {
                    stateLabel:                     si.getLocalizedStringEnc('offline_manager_cache_state_label'),
                    none:                           si.getLocalizedStringEnc('offline_manager_cache_state_none'),
                    invalid:                        si.getLocalizedStringEnc('offline_manager_cache_state_invalid'),
                    valid:                          si.getLocalizedStringEnc('offline_manager_cache_state_valid'),
                    needsUpdate:                    si.getLocalizedStringEnc('offline_manager_cache_state_needs_update'),
                    creatingNew:                    si.getLocalizedStringEnc('offline_manager_cache_create_new'),
                    updateLabel:                    si.getLocalizedStringEnc('offline_manager_cache_update_label'),
                },
                enableLabel:                        si.getLocalizedStringEnc('offline_manager_enable_label'),
                needsReloadLabel:                   si.getLocalizedStringEnc('offline_manager_needs_reload_label'),
                reloadBtn:                          si.getLocalizedStringEnc('offline_manager_needs_reload_button'),
                alertOk:                            si.getLocalizedStringEnc('alert_ok'),
                errorTitle:                         si.getLocalizedStringEnc('alert_error_title'),
                createNewCacheErrorMsg:             si.getLocalizedStringEnc('offline_manager_create_new_cache_error_msg'),
                storageExceededErrorMsg:            si.getLocalizedStringEnc('offline_manager_storage_exceeded_error_msg'),
            }
        });
    }

    onServiceWorkerMessage(event)    {
        //console.log('OEOfflineManagerController onServiceWorkerMessage - ', event.data.type);

        if([ServiceWorkerClientMessageType.onEnableStateChanged,
            ServiceWorkerClientMessageType.onCurrentEnableStateChanged,
            ServiceWorkerClientMessageType.onCacheStateChanged,
            ServiceWorkerClientMessageType.onNewCacheStateChanged
        ].includes(event.data.type))   {
            this.updating(this.updateWorkerState());
        } else if(event.data.type === 'reload')    {
            window.location.reload();
        }
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({uiEnabled: false});
            return;
        }

        retardUpdate(this, () => {
            this.setState({uiEnabled: true});
            this.updateLanguage();
        });
    }

    async updating(promise, updateWorkerState = false)   {
        if(!promise)    return;

        //
        this._updating++;
        if(this.mounted)   this.setState({updating: this._updating > 0});

        //
        let result;
        try {
            const res = await promise;
            result = Promise.resolve(res);
        } catch(error) {
            result = Promise.reject(error);
        }

        //
        if(updateWorkerState)   {
            try {
                await this.updateWorkerState();
            } catch(error) {}

        }

        //
        this._updating--;
        if(this.mounted)   this.setState({updating: this._updating > 0});
    
        return result;
    }

    isUpdating()    {
        return this._updating > 0;
    }

    async updateWorkerState() {
        if(!this.mounted)   return;

        //
        let workerState = this.defaultWorkerState();

        try {
            if(await ServiceWorkerTool.isReady)   {
                const isReady = await ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.getIsReady});

                workerState.isReady             = isReady;
                workerState.enabled             = await ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.getEnabled});
                workerState.currentEnabled      = await ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.getCurrentEnabled});
                workerState.cacheState          = await ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.getCacheState});
                workerState.currentCacheState   = await ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.getCurrentCacheState});
                workerState.newCacheState       = await ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.getNewCacheState});
            }
        } catch(error) {
            console.log('OEOfflineManagerController - updateWorkerState failed with: ' + error.message);
            return;
        }

        //
        if(!this.mounted)   return;

        //
        if(OEToolbox.shallowEqual(this.workerState, workerState, true)) {
            this.setState({workerStateUpdated: true});
            return;
        }

        //
        this.workerState = workerState;
        this.setState({workerState: clone(this.workerState), workerStateUpdated: true});
    }

    renderContent() {
        if(!this.state.workerStateUpdated && this.props.hideWithoutWorkspaceUpdate)  return null;

        const strings = this.state.strings;
        const workerState = this.state.workerState;
        const uiEnabled = this.state.uiEnabled && workerState.isReady && !this.state.updating && workerState.newCacheState.state !== ServiceWorkerNewCacheState.creating;
        const cacheInPlace = workerState.cacheState == ServiceWorkerCacheState.valid || workerState.cacheState == ServiceWorkerCacheState.needsUpdate;
        const currentCacheInPlace = workerState.currentCacheState == ServiceWorkerCacheState.valid || workerState.currentCacheState == ServiceWorkerCacheState.needsUpdate;

        //
        let stateLabel = strings.state.notAvailable;
        if(workerState.isReady)  stateLabel = workerState.currentEnabled && currentCacheInPlace ? strings.state.active : strings.state.available;

        //
        let cacheStateLabel = strings.cache.none;
        if(workerState.cacheState && strings.cache[workerState.cacheState]) cacheStateLabel = strings.cache[workerState.cacheState];

        if(workerState.newCacheState.state === ServiceWorkerNewCacheState.creating && workerState.newCacheState.progress) {
            cacheStateLabel = strings.cache.creatingNew + ` ${Math.round(workerState.newCacheState.progress.value / workerState.newCacheState.progress.count * 100)}%`
        }

        //
        let showReloadBtn = (cacheInPlace && workerState.enabled != workerState.currentEnabled) || (workerState.enabled && workerState.newCacheState.state === ServiceWorkerNewCacheState.ready);

        let reloadBtn = !showReloadBtn ? null :
            <OEButtonControl
                className="opaque-style align-right reload-button"
                title={strings.needsReloadLabel}
                disabled={!(uiEnabled && showReloadBtn)}
                onPressed={this.onReloadBtnPressed}
            >
                {strings.reloadBtn}
            </OEButtonControl>
        ;

        //
        return (
            <React.Fragment>
                <OEGroupControl title={this.props.showTitle ? strings.title : undefined}>

                    <OEControl className="control-label" title={strings.state.label}>
                        <span>{stateLabel}</span>
                    </OEControl>

                    <OEControl className="control-label" title={strings.cache.stateLabel}>
                        <span>{cacheStateLabel}</span>
                    </OEControl>

                    <OEIconButtonControl
                        className="align-right"
                        title={strings.cache.updateLabel}
                        disabled={!(uiEnabled && (this.allowValidCacheUpdates || this.props.devFeatures || workerState.cacheState !== ServiceWorkerCacheState.valid))}
                        icon={OEIconCodes.offlineManagerView.updateCache}
                        onPressed={this.onUpdateCacheBtnPressed}
                    />

                    <OEToggleCheckboxControl
                        className="align-right"
                        title={strings.enableLabel}
                        active={workerState.enabled}
                        disabled={!(uiEnabled && cacheInPlace)}
                        onClick={this.onEnableSwitchChanged}
                    />

                    {reloadBtn}

                </OEGroupControl>
            </React.Fragment>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div className={this.props.className + ' offline-manager-controller'}>
                    {this.renderContent()}
                </div>
            </React.Fragment>
        );
    }

    onUpdateCacheBtnPressed()   {
        if(!this.oe.isReady() || !this.state.uiEnabled || !this.workerState.isReady || this.isUpdating() || this.workerState.newCacheState.state === ServiceWorkerNewCacheState.creating || !(this.allowValidCacheUpdates || this.props.devFeatures || this.workerState.cacheState !== ServiceWorkerCacheState.valid))  return;

        const textureCompressionSupportBits = this.oe.sharedInterface.getTextureCompressionSupportBits();

        this
        .updating(ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.createNewCache, updateDataConfig: true, textureCompressionSupportBits: textureCompressionSupportBits}), true)
        .then(result => {
            if(result === ServiceWorkerResultType.ok)   return result;

            if(result === ServiceWorkerResultType.errorExceededStorage) {
                return navigator.storage.estimate().then(({usage, quota}) => {
                    usage = `${(usage / 1024 / 1024).toFixed(2)} MB`
                    quota = `${(quota / 1024 / 1024).toFixed(2)} MB`

                    this.showModal(this.state.strings.errorTitle, this.state.strings.storageExceededErrorMsg.replaceAll('%IN_USE%', usage).replaceAll('%AVAILABLE%', quota), true);
                    return result;
                });
            }

            this.showModal(this.state.strings.errorTitle, this.state.strings.createNewCacheErrorMsg, true);
            return result;
        });
    }

    onEnableSwitchChanged() {
        if(!this.state.uiEnabled || !this.workerState.isReady || this.isUpdating())  return;

        this.updating(ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.setEnabled, value: !this.workerState.enabled}), true);
    }

    onReloadBtnPressed()    {
        if(!this.state.uiEnabled || !this.workerState.isReady || this.isUpdating() || this.workerState.newCacheState.state === ServiceWorkerNewCacheState.creating)  return;

        let promise = ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.applyChanges}).then(() => {
            return ServiceWorkerTool.postMessageR({type: ServiceWorkerMessageType.postMessageToClients, message: {type: 'reload'}});
        });

        this.updating(promise, true);
    }

    showModal(title, content, isAlert = false)  {
        if(!this.props.appComponent)    return;

        let buttons = (id, container) => [{title: this.state.strings.alertOk, onClick: () => { container.closeModal(id) }, className: 'btn-primary'}];

        this.props.appComponent.module.addModal(title, content, buttons, !isAlert ? {style: OEModalStyle.message} : undefined);
    }
}

OEOfflineManagerController.defaultProps = OEOfflineManagerProps.controllerDefaultProps;

OEOfflineManagerController.propTypes = OEOfflineManagerProps.controller;

//
export const OEOfflineManagerPopover = OEPopover.coat(OEOfflineManagerController, {
}, {
    className:                  'offline-manager',
    placement:                  'top',
    hideArrow:                  true,
    noHeader:                   true,
    buttonClassName:            'transparent-btn',
}, {
    controllerClassName:        PropTypes.string
});

//
export default frefFromRef(connectAppEnv((env) => {
    const ui = env.config.module.uiLayerConfig;
    const top = ui.mainMenuButtons.right.findIndex(entry => entry.type === OEMainMenuStdBtnType.offlineManager) >= 0;
    return {
        appComponent:           env.component,
        placement:              top ? 'top' : 'auto',
        hideArrow:              top,
        noHeader:               top,
        titleId:                'offline_manager_view',
        showTitle:              top,
        hideWithoutWorkspaceUpdate: top,
        devFeatures:            env.config.module.flags && env.config.module.flags.includes(AppFlags.import)
    }
})(frefToRef(withIsOpenState(OEOfflineManagerPopover, (sender, isOpen) => {
        let appComponent = sender.props.appComponent;
        if(!appComponent || !appComponent.uiLayer) return;
        appComponent.uiLayer.notificationCenter.post(OENotification.viewOpenStateChanged, {
            type:               OEViewType.offlineManager,
            isOpen:             isOpen,
            sender:             sender
        });
    }))
));